export default "__VITE_ASSET__WOONQ$Cd__"